
  <awn-client-request-panel [instance]="instance$ | async" [dataSelector]="dataSelector + '-panel'"></awn-client-request-panel>
